import React from "react";
import * as psdaAssets from "@tvet-mis/psda-assets";
import { OptimizedSvg } from "@components/common/OptimizedSvg";

const assetsRecord = psdaAssets as unknown as Record<string, string>;
const sidebarLogo = assetsRecord.authCommonLogo || assetsRecord.applicationLogoV2;

/** Logo in the sidebar header — same asset + styling as institute portal. */
const SidebarLogo: React.FC = () => (
	<div className="sidebar-header w-full">
		<div className="sidebar-branding flex w-full shrink-0 flex-col items-center text-center">
			<OptimizedSvg
				src={sidebarLogo}
				alt="Skills Punjab"
				className="sidebar-branding__logo sidebar-branding__logo--expanded [&>svg]:h-full [&>svg]:w-auto [&>svg]:max-w-full"
				cacheKey="sidebar-brand-logo"
			/>
		</div>
	</div>
);

export default SidebarLogo;
